import { IconAddBorderless } from "@rhumbix/rmbx_design_system_web"

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getSelectorActionButtons = () => ({
    createNewTimecardButton: {
        value: "createNewTimecardCell",
        customContent: {},
        label: "Create New Timecard",
        data: {},
        isActionButton: true,
        icon: <IconAddBorderless className="icon-action" />,
    },
})
